export const PANEL_LAYOUT_DEFAULTS = {
  contentPadding: 'var(--layout-panel-content-padding-default)',
  headerHeight: 'var(--layout-header-height-default)',
  headerHorizontalPadding: 'var(--layout-header-horizontal-padding-default)',
  leftSidebarWidth: 'var(--layout-left-sidebar-width-default)',
  mainContentMaxWidth: 'var(--layout-main-content-max-width-default)',
  rightSidebarWidth: 'var(--layout-right-sidebar-width-default)',
  sidebarCollapsedWidth: 'var(--layout-sidebar-collapsed-width-default)',
  sidebarToggleBorderRadius: 'var(--layout-sidebar-toggle-border-radius-default)',
  sidebarToggleFontSize: 'var(--layout-sidebar-toggle-font-size-default)',
  sidebarToggleInlinePadding: 'var(--layout-sidebar-toggle-inline-padding-default)',
  sidebarToggleMinSize: 'var(--layout-sidebar-toggle-min-size-default)',
  sidebarWidth: 'var(--layout-sidebar-width-default)',
} as const;
